import { MOSIDA_API_BASE_URL } from "../config/apiUrls";

const apiBase = MOSIDA_API_BASE_URL;

export interface AiSelfieCategory {
  id: string;
  name: string;
  slug: string | null;
  description: string | null;
  status: boolean;
  sort_order: number | null;
  display_id: string | null;
  icon: string | null;
  icon_url: string | null;
  main_image_url: string | null;
  thumbnail_url: string | null;
  image?: string | null;
  background_image?: string | null;
  inner_bg_image?: string | null;
  created_at: string;
  updated_at: string;
}

function getHeaders(): HeadersInit {
  return {
    accept: "*/*",
  };
}

export function aiSelfieCategoryImageUrl(category: Partial<AiSelfieCategory>): string {
  return (
    category.image ||
    category.main_image_url ||
    category.thumbnail_url ||
    category.icon_url ||
    category.icon ||
    ""
  );
}

/** Full-screen idle / category background from API (not the card portrait). */
export function aiSelfieCategoryBackgroundUrl(category: Partial<AiSelfieCategory>): string {
  const u = category.background_image?.trim();
  return u || "";
}

export async function getActiveAiSelfieCategories(): Promise<{
  success: boolean;
  data: AiSelfieCategory[];
  error?: string;
}> {
  try {
    const response = await fetch(`${apiBase}/ai-selfie-categories/active`, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      const text = await response.text();
      return {
        success: false,
        data: [],
        error: `Failed to load AI selfie categories: ${response.status} ${text}`,
      };
    }

    const json = await response.json();
    const data = Array.isArray(json?.data) ? json.data : [];
    return {
      success: Boolean(json?.success !== false),
      data,
      error: json?.message,
    };
  } catch (error: any) {
    return {
      success: false,
      data: [],
      error: error?.message || "Network error while loading AI selfie categories",
    };
  }
}
